module.exports = __webpack_public_path__ + "img/Octagon.f7472070.svg";